import React, { useEffect, useState, useContext, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import './BoardCodePage.css';

function BoardCodeListPage() {
  const [codes, setCodes] = useState([]);
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  const fetchCodes = useCallback(async () => {
    try {
      const res = await axios.get('/api/board-codes', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCodes(res.data);
    } catch (err) {
      console.error('게시판 코드 목록 조회 실패:', err);
      alert('목록을 불러오지 못했습니다');
    }
  }, [token]);

  useEffect(() => {
    fetchCodes();
  }, [fetchCodes]);

  const handleDelete = async (id) => {
    try {
      await axios.patch(`/api/board-codes/${id}/deactivate`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchCodes();
    } catch (err) {
      console.error('게시판 코드 삭제 실패:', err);
      alert('삭제 중 오류 발생');
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">

          {/* 헤더 영역 */}
          <div className="d-flex justify-content-between align-items-center mb-3 boardcodes-header">
            <h4 className="mb-0">📑 게시판 코드 목록</h4>
            <button
              className="btn btn-success"
              onClick={() => navigate('/board-codes/new')}
            >
              + 새 코드 추가
            </button>
          </div>

          {/* 코드 목록 */}
          {codes.length === 0 ? (
            <div className="boardcodes-empty">
              <p>게시판 코드가 없습니다.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-nowrap align-middle table-hover mb-0 boardcodes-table">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '10%' }}>ID</th>
                    <th style={{ width: '20%' }}>코드명</th>
                    <th style={{ width: '20%' }}>코드</th>
                    <th style={{ width: '30%' }}>설명</th>
                    <th style={{ width: '20%' }} className="text-center">관리</th>
                  </tr>
                </thead>
                <tbody>
                  {codes.map((c) => (
                    <tr key={c.id}>
                      <td>{c.id}</td>
                      <td
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate(`/board-codes/${c.id}`)}
                      >
                        <h5 className="font-size-14 mb-0">{c.name}</h5>
                      </td>
                      <td>{c.code}</td>
                      <td>{c.description}</td>
                      <td className="text-center">
                        <button
                          className="btn btn-warning btn-sm me-2"
                          onClick={() => navigate(`/board-codes/${c.id}/edit`)}
                        >
                          수정
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(c.id)}
                        >
                          삭제
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BoardCodeListPage;